export default __webpack_public_path__ + "static/13-92263f38fd27c88a0127bc48e010b3d0.jpg";